import React from "react";
import Singer from "react-photo-gallery";
import { singerdata } from "./photos";
import { useWindowSize } from "./useWindowSize";

function ImgGallery() {
  const { width } = useWindowSize();
  let columns;
  if (width < 600) {
    columns = 2;
  } else if (width < 830) {
    columns = 3;
  } else if (width < 1024) {
    columns = 3;
  } else if (width < 1280) {
    columns = 4;
  } else {
    columns = 4;
  }

  return (
    <div>
      <Singer photos={singerdata} direction={"column"} columns={columns} />
    </div>
  );
}

export default ImgGallery;
